import { ROLE_LABELS } from "@/lib/api";

const STYLES = {
  admin: "bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/20",
  manager: "bg-indigo-50 text-indigo-700 ring-1 ring-inset ring-indigo-600/20",
  member: "bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-600/20",
  viewer: "bg-slate-100 text-slate-700 ring-1 ring-inset ring-slate-600/20",
};

export default function RoleBadge({ role }) {
  const cls = STYLES[role] || STYLES.viewer;
  return (
    <span
      data-testid={`user-role-badge-${role}`}
      className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ${cls}`}
    >
      {ROLE_LABELS[role] || role}
    </span>
  );
}
